import { render } from "./forget.vue?vue&type=template&id=3f3dc10e&scoped=true"
import script from "./forget.vue?vue&type=script&lang=js"
export * from "./forget.vue?vue&type=script&lang=js"

import "./forget.vue?vue&type=style&index=0&id=3f3dc10e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3f3dc10e"

export default script